const getters = {
  job: state => state.job,
  companies: state => state.companies,
  company: state => state.company,
  global_jobs: state => state.global_jobs,
}
export default getters
